import moment from "moment";
import React from "react";
import styled from "styled-components";
import {capitalizeFirstLetter, getAvatarUrl} from "utils";
import {images} from "utils/constants";
import {defaultThemeColors, fonts} from "ui/theme";
import {UserIcon} from "../../../../ui/icons";

const ADMIN_USER_NAME = "Teache Team";

export const NotificationItem = ({item, currentRole, onPress}) => {
    const [isVisible, setIsVisible] = React.useState(false)
    const ref = React.useRef(null)
    const isRead = item?.status === "read";
    const formattedDate = moment(item?.updated_at).format("MMM DD  h:mm A");

    const profilePic =
        currentRole === 1
            ? item?.sender_data_teacher?.profile_pic
            : item?.sender_data?.profile_pic;


    const isAdmin = item?.class_notification_type === "admin_message"
    const image = isAdmin
        ? images.Admin
        : getAvatarUrl(profilePic)

    const title = isAdmin ? ADMIN_USER_NAME
        : item?.sender_data?.first_name +
        " " +
        item?.sender_data?.last_name.charAt(0).toUpperCase()

    React.useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting)
            },
            {
                threshold: 0.5,
                rootMargin: "0px",
            },
        )

        if (ref.current) {
            observer.observe(ref.current)
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current)
            }
        }
    }, [])


    return (
        <StyledCard
            ref={ref}
            isRead={isRead}
            isVisible={isVisible}
            onClick={() => onPress?.(item)}
        >
            <CardHeader>
                <HeaderContent>
                    <UserImageContainer isRead={isRead}>
                        {image
                            ? <UserImage src={image}
                                         alt={`${item?.sender_data?.first_name} ${item?.sender_data?.last_name}`}/>
                            : <UserIcon width='21' height='21'/>
                        }
                    </UserImageContainer>
                    <TitleContainer>
                        <Title>{title}</Title>
                        {!isRead && <StyledBadge>New</StyledBadge>}
                    </TitleContainer>
                </HeaderContent>
            </CardHeader>
            <CardContent>
                <Message>
                    {capitalizeFirstLetter(item?.json_data?.place_holder?.toLowerCase())}
                </Message>
                <TimeContainer>
                    <TimeText>{formattedDate}</TimeText>
                </TimeContainer>
            </CardContent>
        </StyledCard>
    );
}

const StyledCard = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0.5rem 1rem 0.5rem 0.2rem;
    border-radius: 0.5rem;
    background-color: ${(props) => (props.isRead ? "white" : defaultThemeColors.lightBlue)};
    border: 1px solid ${(props) => (props.isRead ? defaultThemeColors.lightBlue : defaultThemeColors.lightBlue)};
    border-left: ${(props) => (props.isRead ? "1px solid #EDF0FF" : "4px solid #554DF1")};

    /* Animation styles */
    opacity: ${(props) => (props.isVisible ? 1 : 0)};
    transform: translateY(${(props) => (props.isVisible ? '0' : '6px')}) scale(${(props) => (props.isVisible ? 1 : 0.95)});
    transition: all 0.5s ease-out;

    box-shadow: 0 1px 3px ${defaultThemeColors.lightBlue};
    overflow: hidden;
    cursor: pointer;

    &:hover {
        scale: 1.01;
    }
`

const CardHeader = styled.div`
    display: flex;
    flex: 2;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding-left: 1rem;
`

const HeaderContent = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`

const UserImageContainer = styled.div`
    overflow: hidden;
    border-radius: 9999px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2.5rem;
    width: 2.5rem;
    ${(props) =>
            !props.isRead &&
            `
    box-shadow: 0 0 0 2px #6052E4;
  `}
`

const UserImage = styled.img`
    height: 100%;
    width: 100%;
    object-fit: cover;
`

const TitleContainer = styled.div``

const Title = styled.h3`
    font-weight: 500;
    font-size: 0.875rem;
`

const StyledBadge = styled.span`
    display: inline-flex;
    align-items: center;
    background-color: ${defaultThemeColors.blue};
    color: white;
    font-size: 0.75rem;
    padding: 0.125rem 0.375rem;
    border-radius: 9999px;
    font-weight: 500;
`

const CardContent = styled.div`
    display: flex;
    width: 70%;
    flex-direction: row;
    align-items: center;
    padding-left: 1rem;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: start;
        gap: 0.2rem;
    }
`

const Message = styled.p`
    display: flex;
    flex: 1;
    font-size: 0.875rem;
    font-weight: 500;
    color: ${defaultThemeColors.txt};
`

const TimeContainer = styled.div`
    display: flex;
    align-items: center;
`

const TimeText = styled.span`
    font-size: ${fonts.sizes.small};
    color: ${defaultThemeColors.placeholder};
    font-weight: 500;
`